module.exports = __webpack_public_path__ + "a5c08d689598e381be0d7c54cb288931.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/font/OpenSans-Bold.svg
 ** module id = 912
 ** module chunks = 9
 **/